// extracted by mini-css-extract-plugin
module.exports = {"input":"FormRight_input__gRRt4","label":"FormRight_label__rKqFR"};